import compose from 'lodash/fp/compose';

import { canAdd, canUpdate } from '../plugins';
import groupDeepLinksApi from '../../firebase/groupDeepLinks';
import PluggableModule from '../pluggable';
import { generateDeepLink } from '../../firebase/utils';
import { parseGcsUrl } from '../../utils/url';

// NOTE: `groupLink` is not the actual collection name.
// No support for sub-collections yet, plugins may not work with this module
const groups = new PluggableModule('group_deep_link');

const ucName = 'GROUP_DEEP_LINK';
const LOADING_INIT = `${ucName}_LOADING_INIT`;
const LOADING_DONE = `${ucName}_LOADING_DONE`;
const LOADING_ERROR = `${ucName}_LOADING_ERROR`;

groups.addMutationTypes(['GROUP_LINKS_SELECTED_LOADING']);

groups.extend({
  namespaced: true,
  state: {
    selectedLoading: false,
    selectedError: null,
    selected: null
  },
  mutations: {
    [LOADING_INIT](state) {
      state.selectedLoading = true;
    },
    [LOADING_DONE](state, data) {
      state.selectedLoading = false;
      state.selected = data;
    },
    [LOADING_ERROR](state, data) {
      state.selectedLoading = false;
      state.selectedError = data;
    }
  },
  actions: {
    async addDeepLink({ commit }, data) {
      commit(groups.con.GROUP_DEEP_LINK_SUBMIT_INIT);
      try {
        const ref = await groupDeepLinksApi.add(data);
        commit(groups.con.GROUP_DEEP_LINK_CREATED, ref.id);
        commit(groups.con.GROUP_DEEP_LINK_SUBMIT_DONE);
      } catch (error) {
        commit(groups.con.GROUP_DEEP_LINK_SUBMIT_DONE);
        throw error;
      }
    },
    async getDeepLink(
      { commit, dispatch },
      {
        groupId,
        concept: { id: conceptId, name: conceptName, poster: conceptPoster }
      }
    ) {
      commit(LOADING_INIT);
      try {
        let linkData = await groupDeepLinksApi.get({
          conceptId,
          groupId
        });
        if (!linkData) {
          const { shortLink: deepLink } = await generateDeepLink(
            `/concepts/${conceptId}?attemptTags=${groupId}`,
            conceptName,
            'Learn this concept on the Madam Curious app!',
            parseGcsUrl(conceptPoster)
          );
          await dispatch('addDeepLink', {
            conceptId,
            groupId,
            url: deepLink
          });
          linkData = { url: deepLink };
        }
        commit(LOADING_DONE, linkData);
      } catch (error) {
        commit(LOADING_ERROR, error);
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate()
);

export default hop(groups);
